import React, { useLayoutEffect, useState } from "react";
import { useLocation } from "@reach/router";
import Header from "./header";
import Footer from "./footer";
import { HeroProvider } from "../contexts/hero-context";
import { cn } from "../util";
import "../styles/global.scss";

const Layout = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true);
  const location = useLocation();

  // Ensure visible on route change (e.g. after client nav)
  useLayoutEffect(() => {
    setIsVisible(true);
  }, [location.pathname]);

  return (
    <HeroProvider>
      <div
        className={cn(
          `transition-opacity duration-500 ${isVisible ? "opacity-100" : "opacity-0"}`,
        )}
      >
        <Header />
        <main>{children}</main>
        <Footer />
      </div>
    </HeroProvider>
  );
};

export default Layout;
